import type { ReactNode } from 'react';
import type { NavGroup, TopTab } from '@/shared/types/navigation';
import { useUiStore } from '@/app/store/ui.store';
import { Sidebar } from './Sidebar';
import { Gnb } from './Gnb';

interface AppShellProps {
  variant: 'admin' | 'medical';
  children: ReactNode;
  navGroups?: NavGroup[];
  topTabs?: TopTab[];
}

export function AppShell({ variant, children, navGroups = [], topTabs = [] }: AppShellProps) {
  const isCollapsed = useUiStore((s) => s.isSidebarCollapsed);
  const hasSidebar = navGroups.length > 0;

  return (
    <>
      <Gnb variant={variant} topTabs={topTabs} />
      {hasSidebar && <Sidebar navGroups={navGroups} />}
      <div
        className={[
          'content-wrapper',
          variant === 'medical' && !hasSidebar ? 'content-wrapper--v3' : '',
          hasSidebar && isCollapsed ? 'content-wrapper--collapsed' : '',
          !hasSidebar ? 'content-wrapper--full' : '',
        ].join(' ')}
      >
        <main id="content">{children}</main>
      </div>
    </>
  );
}
